import { getApiImplementation } from "../BaseApi";
import { TOKEN_KEY } from "../Constants";

export default class BaseApiUploadRequest {
  getData = () => {
    const accessToken = sessionStorage.getItem(TOKEN_KEY);
    const body = this.getBody();
    return getApiImplementation()
      .callApi(this.getMethod(), this.getUrl(), body, accessToken)
      .then((response) => {
        if (!response) {
          throw new Error("responese undefined");
        }
        return response;
      })
      .catch((error) => {
        throw error;
      });
  };
}
